<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {HOTEL} from '@/utils/hotels/hotels-const'

    @Component
    export class HotelStoreMixin extends Vue {
        get productStore() {
            return hotelsStore
        }

        get productRuntimeStore() {
            return hotelsRuntimeStore
        }

        get productType() {
            return HOTEL
        }
    }

    export default HotelStoreMixin
</script>
